import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// import { BookingConfirmationComponent } from 'src/app/shared/booking-confirmation/booking-confirmation.component';
import { DataService, HttpService, LoaderService } from '../../../services';

@Component({
  selector: 'app-hotel-acknowledgement',
  templateUrl: './hotel-acknowledgement.component.html',
  styleUrls: ['./hotel-acknowledgement.component.scss']
})
export class HotelAcknowledgementComponent implements OnInit {
  viewMore = false;
  list;
  bookingID: FormGroup; // = 337 this is for hardcode testing
  passangerList = this.data.passanger;
  showPolicy = true;
  constructor(public data: DataService, public http: HttpService, loaderService: LoaderService, private router: Router, private route: ActivatedRoute,
    private fb: FormBuilder,) {
    route.params.subscribe((params) => {
      this.bookingID = this.fb.group ({
        id: (params['id']),
      });
    });
  }

  ngOnInit(): void {
    this.http.hotelget(`booking/booking-detail?booking_id=${this.bookingID.value.id}`).subscribe ((res) => {
      if (res.statusCode === 200) {
        this.list = res.data.details;
        if(this.list.room_details[0].cancellation_policy === null){
          this.showPolicy = false;
        }else{this.showPolicy = true};
      }
    });
  }
}
